module.exports = __webpack_public_path__ + "media/images/spinning-circles-9f2bf572e15d4e6cdedec83459b1cf8c.svg";